export const calendarConfig = {
  DEFAULT_TIME_ZONE: "Europe/Paris",

  DAY_LABELS: [
    "Luni",
    "Marți",
    "Miercuri",
    "Joi",
    "Vineri",
    "Sâmbătă",
    "Duminică",
  ],

  MONTH_LABELS: [
    "Ianuarie",
    "Februarie",
    "Martie",
    "Aprilie",
    "Mai",
    "Iunie",
    "Iulie",
    "August",
    "Septembrie",
    "Octombrie",
    "Noiembrie",
    "Decembrie",
  ],

  HOUR_START: 7,
  HOUR_END: 22,
  HOURS: Array.from({ length: 22 - 7 }, (_, i) => 7 + i),

  TIME_OPTIONS: (() => {
    const opts = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hh = String(h).padStart(2, "0");
        const mm = String(m).padStart(2, "0");
        opts.push(`${hh}:${mm}`);
      }
    }
    return opts;
  })(),
};
